import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class NotificationService {
   sendNotificationMessage: Subject<string> = new Subject<string>();
constructor(private httpClient:HttpClient) { }
sendMessage(notificationCount: string) {
   this.sendNotificationMessage.next(notificationCount);
 }
getAllNotification(){
   return this.httpClient.get(`UserNotificationLogs/list`);
}
getUnreadNotificationCount(){
   return this.httpClient.get(`UserNotificationLogs/unread-notification`);
}
getUnreadMessageCount(){
   return this.httpClient.get(`MessageGroups/unread-messages`);
}
readNotificationUpdation(logId){
   return this.httpClient.patch(`UserNotificationLogs/${logId}/read`, {});
}
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/services/notification.service.ts